// Role-based tab configuration
export const SUPERVISOR_TABS = {
  assigned: {
    key: "assigned",
    label: "Assigned Tickets",
    status: "assigned",
    count: (stats) => stats?.assigned_tickets || 0,
  },
  in_progress: {
    key: "in_progress",
    label: "In Progress",
    status: "work_started",
    count: (stats) => stats?.work_started_tickets || 0,
  },
  completed: {
    key: "completed",
    label: "Completed",
    status: "work_completed",
    count: (stats) => stats?.work_completed_tickets || 0,
  },
  all: {
    key: "all",
    label: "All Tickets",
    status: null,
    count: (stats) => stats?.total_tickets || 0,
  },
};

export const MANAGER_TABS = {
  assignment: {
    key: "assignment",
    label: "Ticket Assignment/Open Tickets",
    status: "opened",
    count: (stats) =>
      Number(stats?.opened_tickets) + Number(stats?.reopened_tickets) || 0,
  },
  // open: {
  //   key: "open",
  //   label: "Open",
  //   status: "opened",
  //   count: (stats) => stats?.opened_tickets || 0,
  // },
  assigned: {
    key: "assigned",
    label: "Assigned Tickets",
    status: "assigned",
    count: (stats) => stats?.assigned_tickets || 0,
  },
  in_progress: {
    key: "in_progress",
    label: "In Progress",
    status: "work_started",
    count: (stats) => stats?.work_started_tickets || 0,
  },
  work_completed: {
    key: "work_completed",
    label: "Work Completed",
    status: "work_completed",
    count: (stats) => stats?.work_completed_tickets || 0,
  },
  resolved: {
    key: "resolved",
    label: "Resolved(FD)",
    status: "resolved",
    count: (stats) => stats?.resolved_tickets || 0,
  },
  verify_and_closed: {
    key: "verify_and_closed",
    label: "Verify and Closed",
    status: "verified_and_closed",
    count: (stats) => stats?.verified_and_closed_tickets || 0,
  },
  rejected_by_mgr_tickets: {
    key: "rejected_by_mgr_tickets",
    label: "Rejected by Manager",
    status: "rejected_by_mgr",
    count: (stats) => stats?.rejected_by_mgr_tickets || 0,
  },
  rejected_tickets: {
    key: "rejected_tickets",
    label: "Rejected by FD",
    status: "rejected",
    count: (stats) => stats?.rejected_tickets || 0,
  },
  reopened: {
    key: "reopened",
    label: "Re Opened",
    status: "re_opened",
    count: (stats) => stats?.reopened_tickets || 0,
  },
  my_assigned: {
    key: "my_assigned",
    label: "My Assigned Tickets",
    status: "assigned",
    count: (stats) => stats?.my_assigned_tickets || 0,
  },
  my_in_progress: {
    key: "my_in_progress",
    label: "My In Progress Tickets",
    status: "work_started",
    count: (stats) => stats?.my_work_started_tickets || 0,
  },
  my_completed: {
    key: "my_completed",
    label: "My Completed Tickets",
    status: "work_completed",
    count: (stats) => stats?.my_work_completed_tickets || 0,
  },
  verification: {
    key: "verification",
    label: "Pending Verification",
    status: "resolved",
    count: (stats) => stats?.resolved_tickets || 0,
  },
  all: {
    key: "all",
    label: "All Tickets",
    status: null,
    count: (stats) => stats?.total_tickets || 0,
  },
  sla_breached: {
    key: "sla_breached",
    label: "⚠️ SLA Breached",
    status: "sla_breached",
    count: (stats) => stats?.sla_breached_tickets || 0,
    showCondition: (stats) => (stats?.sla_breached_tickets || 0) > 0,
  },
};

export const RECEPTIONIST_TABS = {
  my_tickets: {
    key: "my_tickets",
    label: "My Tickets",
    status: null,
    count: (stats) => stats?.total_tickets || 0,
  },
  pending_resolution: {
    key: "pending_resolution",
    label: "Pending Resolution",
    status: "work_completed",
    count: (stats) => stats?.work_completed_tickets || 0,
  },
};

export const ADMIN_TABS = {
  analytics: {
    key: "analytics",
    label: "Analytics",
    status: null,
    // count: (stats) => stats?.total_tickets || 0,
  },
  all: {
    key: "all",
    label: "All Tickets",
    status: null,
    count: (stats) => stats?.total_tickets || 0,
  },
  open: {
    key: "open",
    label: "Open",
    status: "opened",
    count: (stats) => stats?.opened_tickets || 0,
  },
  assigned: {
    key: "assigned",
    label: "Assigned",
    status: "assigned",
    count: (stats) => stats?.assigned_tickets || 0,
  },
  in_progress: {
    key: "in_progress",
    label: "In Progress",
    status: "work_started",
    count: (stats) => stats?.work_started_tickets || 0,
  },
  work_completed: {
    key: "work_completed",
    label: "Work Completed",
    status: "work_completed",
    count: (stats) => stats?.work_completed_tickets || 0,
  },
  resolved: {
    key: "resolved",
    label: "Resolved(FD)",
    status: "resolved",
    count: (stats) => stats?.resolved_tickets || 0,
  },
  verify_and_closed: {
    key: "verify_and_closed",
    label: "Verify and Closed",
    status: "verified_and_closed",
    count: (stats) => stats?.verified_and_closed_tickets || 0,
  },
  rejected_by_mgr_tickets: {
    key: "rejected_by_mgr_tickets",
    label: "Rejected by Manager",
    status: "rejected_by_mgr",
    count: (stats) => stats?.rejected_by_mgr_tickets || 0,
  },
  rejected_tickets: {
    key: "rejected_tickets",
    label: "Rejected by FD",
    status: "rejected",
    count: (stats) => stats?.rejected_tickets || 0,
  },
  reopened: {
    key: "reopened",
    label: "Re Opened",
    status: "reopened",
    count: (stats) => stats?.reopened_tickets || 0,
  },
  sla_breached: {
    key: "sla_breached",
    label: "⚠️ SLA Breached",
    status: "sla_breached",
    count: (stats) => stats?.sla_breached_tickets || 0,
    showCondition: (stats) => (stats?.sla_breached_tickets || 0) > 0,
  },
};
